import React from 'react';

const Testimonials = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Testimonials</h2>
    <p className="text-gray-600">This is the Testimonials page.</p>
  </div>
);

export default Testimonials;
